module.exports = __webpack_public_path__ + "static/frog4-f9d5b677851f249e0d0d0c85791bb10b.png";